import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { IoCall } from "react-icons/io5";

const Help = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <span
        className="d-lg-none"
        style={{ fontSize: "14px", color: "grey", fontWeight: "bold" }}
        onClick={handleShow}
      >
        {t("CM.FT.COL3.L4")}?
      </span>
      <Offcanvas
        className="w-75"
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header className="all_background" closeButton>
          <Offcanvas.Title>{t("TXT.CONCT.US.LO")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body
          translate="no"
          style={{ display: "flex", flexDirection: "column", gap: "4px" }}
        >
          <a
            style={{
              textDecoration: "none",
              color: "black",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              userSelect: "none",
              WebkitTapHighlightColor: "transparent",
            }}
            href={`tel:${t("CM.FT.COL5.CNT3")}`}
            rel="nofollow"
          >
            <IoCall /> 9363919110
          </a>
          <a
            style={{
              textDecoration: "none",
              color: "black",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              userSelect: "none",
              WebkitTapHighlightColor: "transparent",
            }}
            href={`tel:${t("CM.FT.COL5.CNT4")}`}
            rel="nofollow"
          >
            <IoCall /> 9363919113
          </a>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Help;
